/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Group_ReadyInputs */



/**
* | output |
* | --- |
* | "Ready to invoice" |
*
* @param {Partner_Billing_Board_Group_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_group_ready = /** @type {((inputs?: Partner_Billing_Board_Group_ReadyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Group_ReadyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereit zur Fakturierung")
	return /** @type {LocalizedString} */ ("Ready to invoice")
});